import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../interactions/interactions';
import '../typography/typography';
import css from './section-link.css';

const SectionLink = React.forwardRef(({ href, title }, ref) => (
  <a className={css['ds-section-link']} href={href} ref={ref}>
    <span>{title}</span>
  </a>
));

SectionLink.displayName = 'SectionLink';

SectionLink.defaultProps = {
  href: '',
};

SectionLink.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string,
};

export default SectionLink;
